/** Reload the page when the server is running a different build (an update was installed): the new screens load and, as every sign-in ended with the update, the sign-in page shows. */
let loaded: string | null = null;

async function check() {
  try {
    const r = await fetch('/api/build', { cache: 'no-store' });
    if (!r.ok) return;
    const { build } = (await r.json()) as { build?: string };
    if (!build) return;
    if (loaded === null) loaded = build;
    else if (build !== loaded) window.location.reload();
  } catch {
    // Server restarting: try again later
  }
}

export function startBuildWatch(everyMs = 120_000) {
  void check();
  setInterval(() => void check(), everyMs);
  window.addEventListener('focus', () => void check());
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') void check(); });
}
